module.exports = __webpack_public_path__ + "img/control.3d133587.svg";